import { Permissions } from '../../../../models/enums/permissions';
import React from "react";
import { uuid } from "uuidv4";
import { ClearButton } from "../../../../components/button/ClearButton";
import { FlatButton } from "../../../../components/button/FlatButton";
import { HasPermission } from "../../../../containers/authorization-helpers/HasPermission";
import { DivisionMetadata } from "../../../../models/ordering/enums/division";
import { formatCurrency } from "../../../../utils/currency-formatter";
import { toSimpleDateTime } from "../../../../utils/date-utils";
import { DealerCredit, DealerCreditLineItem } from "../../../../support/models/dealers/dealer-credit";

interface IProps {
    credit: DealerCredit;
    downloadInvoice: any;
    reverseCredit: any;
}

export const DealerCreditRow = (props : IProps) => {

    const currencyLocale = props.credit.currencyId === 'CAN' ? 'en-CA' : 'en-US';
    return (
        <tr><td>
        <div key={ props.credit.id } className="dealer-credit">
            <div className="credit-header">
                <div>
                    <h2 className="credit-metadata">
                        <ClearButton 
                            id="view-invoice-btn"
                            icon=""
                            onBtnClick={ () => props.downloadInvoice(props.credit.invoiceId, props.credit.invoiceNumber) }
                            text={props.credit.invoiceNumber}
                        />   
                        <span className="badge green">
                            { props.credit.serviceCenterId }
                        </span>
                        <span className="badge orange">
                            { 
                                props.credit.division !== undefined 
                                    ? DivisionMetadata[props.credit.division].abbreviation
                                    : 'Unknown Division' 
                            } 
                        </span>
                        {
                            props.credit.isReversed
                                ? <span className="badge red">Reversed</span>
                                : null
                        }
                    </h2>
                    <p>
                        Created: { props.credit.createdOn ? toSimpleDateTime(props.credit.createdOn) : '' }
                    </p>
                </div>
                <div>
                    <h2 className="credit-total">Total { formatCurrency(props.credit.total.foreign, currencyLocale) }</h2>
                    <p>
                        Freight: { formatCurrency(props.credit.freight.foreign, currencyLocale) } |
                        Tax: { formatCurrency(props.credit.tax.foreign, currencyLocale) }
                    </p>
                </div>
            </div>                                
            <div>
                <p className="credit-note">{ props.credit.note }</p>
            </div>
            {
                props.credit.items && props.credit.items.length > 0
                    ? <table className="table">
                        <thead>
                            <tr>
                                <th>Reason</th>
                                <th>Category</th>
                                <th>Description</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                props.credit.items.map((lItm : DealerCreditLineItem) => 
                                    <tr key={ uuid() }>
                                        <td>{ lItm.reason?.name }</td>
                                        <td>{ lItm.category?.name }</td>
                                        <td>{ lItm.description }</td>
                                        <td>{ formatCurrency(lItm.amount.foreign, currencyLocale) } </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    : null
            }

            <HasPermission requiredPermissions={[
                Permissions.SupportDealersReverseCredit
            ]}>
                <div className="row justify-content-end">
                    <div className="col-auto">
                        <FlatButton
                            id="reverse-btn"
                            classes="negative"
                            text={ props.credit.isReversed ? "Unreverse" : "Reverse"}
                            onBtnClick={ () => props.reverseCredit(props.credit.id, props.credit.isReversed) }
                        />
                    </div>
                </div>
            </HasPermission>
        </div>
        </td></tr>
    );
};
